/* istanbul ignore file */
import { MegaMenuLink } from './MegaMenuLink';

export default MegaMenuLink;
